// extracted by mini-css-extract-plugin
export var container = "index-module--container--xKEQ4";
export var formBox = "index-module--formBox--wPPSP";
export var fullWidth = "index-module--fullWidth--kcM0p";
export var gradBorder = "index-module--gradBorder--bDOj9";
export var header = "index-module--header--qpkkw";
export var inputLabel = "index-module--inputLabel--Zfmbo";
export var messageContainer = "index-module--messageContainer--TVGUT";
export var messagePlaceholder = "index-module--messagePlaceholder--gdD8o";
export var phoneContainer = "index-module--phoneContainer--C31Tq";
export var recaptcha = "index-module--recaptcha--9QNDF";
export var submit = "index-module--submit---Vbzv";
export var submitBox = "index-module--submitBox--pwDF-";
export var subtitle = "index-module--subtitle--LboXo";
export var title = "index-module--title--2Hv4i";
export var ttsFormBytext = "index-module--ttsFormBytext--wlyvN";